<template>
    <section class="multiple-settings">
        <h2>Несколько табелей за месяц</h2>
        <p>Доступно только на объектах без сверки с отчётами. Существующий табель станет «Основным».
            Выберите его ответственного; дополнительные табели редакторы создают для себя.
            Ответственному также нужно право редактирования табелей объекта.</p>
        <b-form-input v-model.trim="query" type="search" placeholder="Найти объект" aria-label="Поиск объекта для нескольких табелей" />
        <div v-for="object in availableObjects" :key="object.building_id" class="multiple-settings__row">
            <b-form-checkbox :checked="Boolean(config(object.building_id))" @change="enabled => toggle(object.building_id, enabled)">
                {{ object.name }}
            </b-form-checkbox>
            <v-select v-if="config(object.building_id)"
                      :value="config(object.building_id).responsible_user_id" :options="users" label="text"
                      :reduce="user => user.value" placeholder="Ответственный за основной табель"
                      :input-id="`primary-responsible-${object.building_id}`"
                      @input="id => setResponsible(object.building_id, id)" />
        </div>
        <p v-if="!availableObjects.length" class="text-muted">Нет подходящих объектов. Сначала отключите сверку с отчётами.</p>
        <small>Часы и оценки между месяцами не копируются. Сохраняются названия, ответственные и исключённые сотрудники.
            После создания именованных табелей отключить режим без разбора их истории нельзя.</small>
    </section>
</template>
<script>
export default {
    props: {value: {type: Array, default: () => []}, objects: {type: Array, default: () => []},
        users: {type: Array, default: () => []}, exemptIds: {type: Array, default: () => []}},
    data: () => ({query: ''}),
    computed: {
        availableObjects() {
            return this.objects.filter(object => (this.exemptIds.map(Number).includes(Number(object.building_id))
                || this.config(object.building_id)) && object.name.toLocaleLowerCase('ru').includes(this.query.toLocaleLowerCase('ru')));
        }
    },
    methods: {
        config(id) { return this.value.find(row => Number(row.building_id) === Number(id)); },
        toggle(id, enabled) {
            const rows = this.value.filter(row => Number(row.building_id) !== Number(id));
            if (enabled) rows.push({building_id: Number(id), responsible_user_id: null});
            this.$emit('input', rows);
        },
        setResponsible(id, userId) {
            this.$emit('input', this.value.map(row => Number(row.building_id) === Number(id)
                ? {...row, responsible_user_id: userId} : row));
        }
    }
};
</script>
<style scoped>
.multiple-settings { padding: 1rem; border: 1px solid #dbe4ec; border-radius: 12px; }
.multiple-settings h2 { font-size: 1.15rem; }
.multiple-settings__row { display: grid; grid-template-columns: 1fr 1fr; gap: .75rem; align-items: center; margin: .8rem 0; }
@media (max-width: 760px) { .multiple-settings__row { grid-template-columns: minmax(0, 1fr); } }
</style>
